export enum LogisticsAudience {
    Courier = 1,
    NKR = 2,
    Center = 3
}